/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmi_metric = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metric`)
};

const es_bmi_metric = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métrico`)
};

const de_bmi_metric = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metrisch`)
};

const nl_bmi_metric = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metrisch`)
};

const fr_bmi_metric = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métrique`)
};

const it_bmi_metric = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metrica`)
};

const pt_br2_bmi_metric = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métrico`)
};

const pt_bmi_metric = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métrico`)
};

const ja_bmi_metric = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メートル法`)
};

const zh_bmi_metric = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公制`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmi_metric = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmi_metric(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmi_metric", locale)
	if (locale === "en") return en_bmi_metric(inputs)
	if (locale === "es") return es_bmi_metric(inputs)
	if (locale === "de") return de_bmi_metric(inputs)
	if (locale === "nl") return nl_bmi_metric(inputs)
	if (locale === "fr") return fr_bmi_metric(inputs)
	if (locale === "it") return it_bmi_metric(inputs)
	if (locale === "pt-BR") return pt_br2_bmi_metric(inputs)
	if (locale === "pt") return pt_bmi_metric(inputs)
	if (locale === "ja") return ja_bmi_metric(inputs)
	return zh_bmi_metric(inputs)
};